export default __webpack_public_path__ + "static/fertilespringbackground-e5e2e0629854168ee56c2440bcca7ab7.jpg";